<template>
  <footer id="footer">
    <!-- START INSTACARES PAGES -->
    <v-col class="pb-0">
      <v-row justify="center" align="center">
        <v-col class="pr-0 pl-0" cols="3">
          <hr />
        </v-col>
        <v-col class="pr-0 pl-0" justify="center" align="center" cols="6">
          <span class="footer-instacares">InstaCares</span>
        </v-col>
        <v-col class="pr-0 pl-0" cols="3">
          <hr />
        </v-col>
      </v-row>
      <v-row justify="center" align="center">
        <v-col class="pa-0 pb-1" justify="center" align="center" cols="6">
          <router-link to="/vantagens">
            <span class="tiny-font">Vantagens</span>
          </router-link>
        </v-col>
        <v-col class="pa-0 pb-1" justify="center" align="center" cols="6">
          <router-link to="/saibamais">
            <span class="tiny-font">Serviços</span>
          </router-link>
        </v-col>
        <v-col class="pa-0 pt-1" justify="center" align="center" cols="6">
          <router-link to="/sobre">
            <span class="tiny-font">Sobre nós</span>
          </router-link>
        </v-col>
        <v-col class="pa-0 pt-1" justify="center" align="center" cols="6">
          <router-link to="/faq">
            <span class="tiny-font">Perguntas frequentes</span>
          </router-link>
        </v-col>
      </v-row>
    </v-col>
    <!-- END INSTACARES PAGES -->
    <!-- START CONTACT US -->
    <v-col class="pt-0 pb-0">
      <v-row justify="center" align="center">
        <v-col class="pr-0 pl-0" justify="center" align="center" cols="12">
          <span class="footer-contact">Contato</span>
        </v-col>
      </v-row>
      <v-row justify="center" align="center">
        <v-col class="pa-0 pb-1" justify="center" align="center" cols="6">
          <span class="tiny-font">
            <v-icon class="title-gray">{{ icons.phone }}</v-icon
            >&nbsp;(11) 99386-3001
          </span>
        </v-col>
        <v-col class="pa-0 pb-1" justify="center" align="center" cols="6">
          <span class="tiny-font">
            <v-icon class="title-gray">{{ icons.phone }}</v-icon
            >&nbsp;(11) 99284-3570
          </span>
        </v-col>
        <v-col class="pa-0" justify="center" align="center" cols="12">
          <router-link to="/contato">
            <span class="tiny-font">contato@instacares.com.br&nbsp;</span>
            <br />
            <span class="tiny-font">Nos envie uma mensagem</span>
          </router-link>
        </v-col>
      </v-row>
    </v-col>
    <!-- END CONTACT US -->
    <!-- START ICON SOCIAL MEDIA -->
    <v-col class="pt-0 pb-0">
      <v-row justify="center" align="center">
        <v-col class="pr-0 pl-0" cols="3">
          <hr />
        </v-col>
        <v-col cols="2" justify="center" align="center">
          <a href="https://www.facebook.com/InstaCares/" target="_blank">
            <img class="icon-size" src="../assets/img/face.svg" />
          </a>
        </v-col>
        <v-col cols="2" justify="center" align="center">
          <a href="https://www.instagram.com/insta_cares/" target="_blank">
            <img class="icon-size" src="../assets/img/insta.svg" />
          </a>
        </v-col>
        <v-col cols="2" justify="center" align="center">
          <a
            href="https://www.youtube.com/channel/UCEff5AfMjocVLOcH2mqPn_g?view_as=subscriber"
            target="_blank"
          >
            <img class="icon-size" src="../assets/img/youtube.svg" />
          </a>
        </v-col>
        <v-col class="pr-0 pl-0" cols="3">
          <hr />
        </v-col>
      </v-row>
    </v-col>
    <!-- END ICON SOCIAL MEDIA -->
    <!-- START EULA -->
    <v-col class="pt-0 pb-0">
      <v-row justify="center" align="center">
        <v-col cols="12" class="pt-0 pb-0" justify="center" align="center">
          <p class="tiny-font">
            <template v-for="(eula, idx) in eulas">
              <span
                @click="fetchEULA(eula)"
                style="cursor: pointer"
                :key="idx"
                >{{ eula.title }}</span
              >
              <br :key="'br-' + idx" />
            </template>
          </p>
        </v-col>
      </v-row>
    </v-col>
    <!-- END EULA -->
    <!-- START DEVELOPED BY -->
    <v-col class="pt-0 pb-0">
      <v-row justify="center" align="center">
        <v-col cols="12" class="pt-0 pb-0" justify="center" align="center">
          <p class="tiny-font mb-0">
            Copyright &copy; 2020 InstaCares Tecnologia Ltda. - Todos os
            direitos reservados
          </p>
        </v-col>
      </v-row>
    </v-col>
    <!-- END DEVELOPED BY -->
  </footer>
</template>

<script>
import axios from 'axios'
import { mdiPhone } from '@mdi/js'

export default {
  components: {},
  data: () => ({
    icons: {
      phone: mdiPhone
    },
    slideIndex: 1,
    eulas: [
      {
        title: 'Termos e Condições',
        type: 'termos_condicoes',
        route: '/termos-condicoes',
        fileUrl: null
      },
      {
        title: 'Termos e Condições Profissionais',
        type: 'termos_condicoes_profissional',
        route: '/termos-condicoes-profissional',
        fileUrl: null
      },
      {
        title: 'Política de Privacidade',
        type: 'politica_privacidade',
        route: '/politica-privacidade',
        fileUrl: null
      }
    ]
  }),
  methods: {
    newTab(url) {
      if (url && url.length > 0) {
        var win = window.open(url, '_blank')
        win.focus()
      }
    },
    fetchEULA(e) {
      //console.log('fetching EULA pdf from server...');
      let vm = this
      vm.loading = true

      axios
        .get(process.env.VUE_APP_ITS_API + 'get/get-termo_eula.php', {
          params: {
            tipo: e.type
          }
        })
        .then(response => {
          vm.loading = false
          switch (response.data.status) {
            case 201:
            case 200:
              e.fileUrl = response.data.data.file
              var win = window.open(e.fileUrl, '_blank')
              win.focus()
              break
            default:
              console.log(response.data.reason)
              break
          }
        })
    }
  }
}
</script>

<style scoped>
.icon-size {
  width: 30px;
}

.footer-contact {
  font-size: 20px;
  font-weight: 900;
  color: #626264;
}

.footer-instacares {
  font-size: 25px;
  font-weight: 900;
  color: #1f396e;
}

hr {
  border: 1px solid #626264;
}

.v-application a {
  text-decoration: none;
  color: unset;
}
</style>
